import { render, staticRenderFns } from "./WeeklyCoursePlanForm.vue?vue&type=template&id=294923a4"
import script from "./WeeklyCoursePlanForm.vue?vue&type=script&lang=js"
export * from "./WeeklyCoursePlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports